// @ts-check

import { objectEntries } from '@erpagroapp/common';

/**
 * @template {Partial<import('./types').ConfigurationParameterProps>} T
 * @param {T} props
 * @returns T
 */
export function defineDefaultProps(props) {
  return props;
}

/**
 * @internal
 * @template {import('./types').ConfigurationParameterInstance} T
 * @param {T} config
 * @returns {import('./types').EnhancedParamsConfigProperty<T>}
 */
export function defineConfig(config) {
  const enhancedProperties = /** @type {import('./types').EnhancedParamsConfigProperty<T>} */ ({});

  objectEntries(config).forEach(([key, prop]) => {
    enhancedProperties[/** @type {keyof T} */ (key)] = /** @type {any} */ ({
      ...prop,
      loadingRules: {
        requiredModuleIds: prop.loadingRules?.requiredModuleIds ?? [],
        requiredProcessIds: prop.loadingRules?.requiredProcessIds ?? [],
      },
    });
  });

  return enhancedProperties;
}

/**
 * @internal
 * @param {string} inputString
 * @returns {boolean}
 */
export function convertParamValueToBoolean(inputString) {
  const truthyValues = ['true', 'yes', '1', 'si'];
  const falsyValues = ['false', 'no', '0', null];

  const normalizedInput = inputString.toLowerCase().trim();

  if (truthyValues.includes(normalizedInput)) {
    return true;
  } if (falsyValues.includes(normalizedInput)) {
    return false;
  }

  return Boolean(normalizedInput);
}
